import { UNIT, BRIGHTNESSMAX, BRIGHTNESSUNIT } from '@/enum/enum';

/**
 * color_range (dynamic range)
 * //0 SDR, 1 HDR, 2 HDR_SDR
 * @param value 
 * @returns 
 */
export const dynamicRangeHandler = (value: number | null) => {
    switch (value) {
        case 0:
            return 'SDR';
        case 1:
            return 'HDR';
        case 2:
            return 'HDR_SDR';
        default:
            return UNIT.NODATA;
    }

} //end: dynamicRangeHandler

/**
 * color gamut
 * @param value 
 * @returns 
 */
export const colorGamutHandler = (value: number | null) => {
    switch (value) {
        case 0:
            return 'SRGB / BT.709';
        case 1:
            return 'ADOBE_RGB';
        case 2:
            return UNIT.NODATA; // Previously it was BT.709
        case 3:
            return 'DCI_P3';
        case 4:
            return 'BT.2020';
        case 5:
            return 'EBU';
        case 6:
            return 'SMPTE-C';
        case 7:
            return 'Custom';
        default:
            return UNIT.NODATA;
    }
} //end: colorGamutHandler

/**
 * Custom Gamut Handler
 * Format gamut_custom object with RGB coordinates
 * @param gamutCustom - Object containing red_x, red_y, green_x, green_y, blue_x, blue_y
 * @returns Formatted string with RGB coordinates
 */
export const gamutCustomHandler = (gamutCustom: any) => {
    if (!gamutCustom) {
        return UNIT.NODATA;
    }

    const { red_x, red_y, green_x, green_y, blue_x, blue_y } = gamutCustom;

    if (red_x === undefined || red_y === undefined ||
        green_x === undefined || green_y === undefined ||
        blue_x === undefined || blue_y === undefined) {
        return UNIT.NODATA;
    }

    // Format numbers to 2 decimal places
    const formatCoord = (num: number) => Number(num).toFixed(2);

    return `Red (${formatCoord(red_x)}, ${formatCoord(red_y)}), Green (${formatCoord(green_x)}, ${formatCoord(green_y)}), Blue (${formatCoord(blue_x)}, ${formatCoord(blue_y)})`;
} //end: gamutCustomHandler

/**
 * Brightness handle
 * @param val   brighness
 * @param minVal  min_brighness
 * @param eotf  eotf
 * @returns 
 */
export const brightnessHandler = (val: string | number, minVal: string | number | null = null, eotf: number = -1) => {
    const _val = val;
    const _minVal = minVal;
    const _eotf = eotf;

    if (_eotf && _eotf === 2) {  //當eotf數值為2的時候會有brightness_min，兩個都要放進brightness裡面 //0421改
        // _val = _minVal
        if (_val) {
            let brightness;
            for (const key in BRIGHTNESSMAX) {
                if (_val == key) {
                    brightness = BRIGHTNESSMAX[key]

                } else {
                    brightness = typeof _val === 'number' ? ` ${_val} ${UNIT.NTM2}` : _val;
                }
            }
            return `${BRIGHTNESSUNIT.lmax} :  ${brightness} <br> ${BRIGHTNESSUNIT.lmin}  : ${_minVal} ${UNIT.NTM2}`
        } else {
            return `${BRIGHTNESSUNIT.lmin} : ${_minVal} ${UNIT.NTM2}`
        }
    } else {
        if (_val) {
            let brightness;
            for (const key in BRIGHTNESSMAX) {
                if (_val == key) {
                    brightness = BRIGHTNESSMAX[key]

                } else {
                    brightness = typeof _val === 'number' ? ` ${_val} ${UNIT.NTM2}` : _val;
                }
            }
            return ` ${brightness}`;
        }
    }
} //end: brightnessHandler

/**
 * color_temperature
 * @param val 
 * @returns 
 */
export const temperatureHander = (val: number | null) => {
    let _val = val;
    const unit = 1;
    if (typeof _val === 'number') {
        return (_val >= unit && _val % unit === 0) ? `${_val / unit} ${UNIT.K}` : _val;
    }
    else {
        return UNIT.NODATA;
    }

}//end: temperatureHander




/**
 * 
 * @param val 
 * @returns 
 */

export const coordinateHandler = (valX, valY) => {
    return `x : ${valX}   y : ${valY}`


}//end:  coordinateHandler





/**
 * 
 * @param val 
 * @returns 
 */

export const colorstandardHandler = (val: number | null) => {
    let _val = val;
    switch (_val) {
        case 0:
            return "D50";
        case 1:
            return "D55";
        case 2:
            return "D65";
        case 3:
            return "DCI-P3";
        default:
            return UNIT.NODATA;
    }
}//end:  colorstandardHandler




/**
 * EOTF 
 * // 0 SRGB, 1 GAMMA, 2 DICOM, 3 PQ, 4 HLG
 * @param value 
 * @returns 
 */
export const eotfHander = (value: number | null, gamma: any = 0) => {
    switch (value) {
        case 0:
            return 'SRGB';
        case 1:
            return `GAMMA ${gamma}`;
        case 2:
            return 'DICOM';
        case 3:
            return 'PQ';
        case 4:
            return 'HLG';
        default:
            return UNIT.NODATA;
    }

}//end: eotfHander

/**
 * 資料為null時顯示nodata
 * @param value 
 * @returns 
 */
export const checkDisplayValue = (value: any = null, eotf: number | null = null) => {
    return eotf == 1 ? null : value === null ? UNIT.NODATA : value;
}
/**
 * 是否為無資料
 * @param value 
 * @returns 
 */
export const isNoData = (value: any) => {
    return value === null || value === UNIT.NODATA;
}

/**
 * 下拉選單中有Dynamic Range
 */
export const optionDynamicRange = [{
    text: 'SDR',
    val: 0
},
{
    text: 'HDR',
    val: 1
},
{
    text: 'HDR_SDR',
    val: 2
}]